export const weekdays = [
    {name: "Montag", short: "Mo"},
    {name: "Dienstag", short: "Di"},
    {name: "Mittwoch", short: "Mi"},
    {name: "Donnerstag", short: "Do"},
    {name: "Freitag", short: "Fr"},
    {name: "Samstag", short: "Sa"},
    {name: "Sonntag", short: "So"}
];

export const repeats = [
    {value: "weekly", label: "pro Woche"},
    {value: "monthly", label: "pro Monat"},
    {value: "block", label: "einmalig"},
    {value: "all_in", label: "Unlimitiert"}
];

export const contractsDeprecated = [
    {value: "all_in", label: "Unlimitiert", tickets: -1},
    {value: "weekly_2", label: "2 pro Woche", tickets: 2},
    {value: "weekly_3", label: "3 pro Woche", tickets: 3},
    {value: "monthly_9", label: "9 pro Monat", tickets: 9},
    {value: "monthly_13", label: "13 pro Monat", tickets: 13},
    {value: "block_10", label: "10er Block", tickets: 10}
];

export const sexes = [
    {value: "male", label: "M"},
    {value: "female", label: "W"},
    {value: "divers", label: "D"}
];

export const repeatOptions = [
    {value: ".", label: "Täglich"},
    {value: "9", label: "Werkstags"},
    {value: "0", label: "Montags"},
    {value: "1", label: "Dienstags"},
    {value: "2", label: "Mittwochs"},
    {value: "3", label: "Donnerstags"},
    {value: "4", label: "Freitags"},
    {value: "5", label: "Samstags"},
    {value: "6", label: "Sonntags"}
];

export const timeWindowOptions = [
    {value: "0", label: "0 min vorher"},
    {value: "5", label: "5 min vorher"},
    {value: "10", label: "10 min vorher"},
    {value: "15", label: "15 min vorher"},
    {value: "30", label: "30 min vorher"},
    {value: "60", label: "1 h vorher"},
    {value: "90", label: "90 min vorher"},
    {value: "120", label: "2 h vorher"},
    {value: "180", label: "3 h vorher"},
    {value: "360", label: "6 h vorher"},
    {value: "480", label: "8 h vorher"},
    {value: "600", label: "10 h min vorher"},
    {value: "-5", label: "5 min nachher"}
];

export const timesOptions = [
    {value: "00:00", label: "00:00"},
    {value: "00:15", label: "00:15"},
    {value: "00:30", label: "00:30"},
    {value: "00:45", label: "00:45"},
    {value: "01:00", label: "01:00"},
    {value: "01:15", label: "01:15"},
    {value: "01:30", label: "01:30"},
    {value: "01:45", label: "01:45"},
    {value: "02:00", label: "02:00"},
    {value: "02:15", label: "02:15"},
    {value: "02:30", label: "02:30"},
    {value: "02:45", label: "02:45"},
    {value: "03:00", label: "03:00"},
    {value: "03:15", label: "03:15"},
    {value: "03:30", label: "03:30"},
    {value: "03:45", label: "03:45"},
    {value: "04:00", label: "04:00"},
    {value: "04:15", label: "04:15"},
    {value: "04:30", label: "04:30"},
    {value: "04:45", label: "04:45"},
    {value: "05:00", label: "05:00"},
    {value: "05:15", label: "05:15"},
    {value: "05:30", label: "05:30"},
    {value: "05:45", label: "05:45"},
    {value: "06:00", label: "06:00"},
    {value: "06:15", label: "06:15"},
    {value: "06:30", label: "06:30"},
    {value: "06:45", label: "06:45"},
    {value: "07:00", label: "07:00"},
    {value: "07:15", label: "07:15"},
    {value: "07:30", label: "07:30"},
    {value: "07:45", label: "07:45"},
    {value: "08:00", label: "08:00"},
    {value: "08:15", label: "08:15"},
    {value: "08:30", label: "08:30"},
    {value: "08:45", label: "08:45"},
    {value: "09:00", label: "09:00"},
    {value: "09:15", label: "09:15"},
    {value: "09:30", label: "09:30"},
    {value: "09:45", label: "09:45"},
    {value: "10:00", label: "10:00"},
    {value: "10:15", label: "10:15"},
    {value: "10:30", label: "10:30"},
    {value: "10:45", label: "10:45"},
    {value: "11:00", label: "11:00"},
    {value: "11:15", label: "11:15"},
    {value: "11:30", label: "11:30"},
    {value: "11:45", label: "11:45"},
    {value: "12:00", label: "12:00"},
    {value: "12:15", label: "12:15"},
    {value: "12:30", label: "12:30"},
    {value: "12:45", label: "12:45"},
    {value: "13:00", label: "13:00"},
    {value: "13:15", label: "13:15"},
    {value: "13:30", label: "13:30"},
    {value: "13:45", label: "13:45"},
    {value: "14:00", label: "14:00"},
    {value: "14:15", label: "14:15"},
    {value: "14:30", label: "14:30"},
    {value: "14:45", label: "14:45"},
    {value: "15:00", label: "15:00"},
    {value: "15:15", label: "15:15"},
    {value: "15:30", label: "15:30"},
    {value: "15:45", label: "15:45"},
    {value: "16:00", label: "16:00"},
    {value: "16:15", label: "16:15"},
    {value: "16:30", label: "16:30"},
    {value: "16:45", label: "16:45"},
    {value: "17:00", label: "17:00"},
    {value: "17:15", label: "17:15"},
    {value: "17:30", label: "17:30"},
    {value: "17:45", label: "17:45"},
    {value: "18:00", label: "18:00"},
    {value: "18:15", label: "18:15"},
    {value: "18:30", label: "18:30"},
    {value: "18:45", label: "18:45"},
    {value: "19:00", label: "19:00"},
    {value: "19:15", label: "19:15"},
    {value: "19:30", label: "19:30"},
    {value: "19:45", label: "19:45"},
    {value: "20:00", label: "20:00"},
    {value: "20:15", label: "20:15"},
    {value: "20:30", label: "20:30"},
    {value: "20:45", label: "20:45"},
    {value: "21:00", label: "21:00"},
    {value: "21:15", label: "21:15"},
    {value: "21:30", label: "21:30"},
    {value: "21:45", label: "21:45"},
    {value: "22:00", label: "22:00"},
    {value: "22:15", label: "22:15"},
    {value: "22:30", label: "22:30"},
    {value: "22:45", label: "22:45"},
    {value: "23:00", label: "23:00"},
    {value: "23:15", label: "23:15"},
    {value: "23:30", label: "23:30"},
    {value: "23:45", label: "23:45"},
    {value: "24:00", label: "24:00"} //todo fails in backend
];

export const roles = [
    {value: -1, label: "Gast"},
    {value: 0, label: "Aktives Miglied"},
    {value: 1, label: "Coach"},
    {value: 2, label: "Inhaber"},
]

export const componentGroups = [
    // {value: "Warum Up", label: "Warum Up", short: "WUP", color: "#914848"},
    // {value: "Skill", label: "Skill", short: "SKILL", color: "rgba(26,239,210,1)"},
    // {value: "Barbell Lifts", label: "Barbell Lifts", short: "OLY", color: "#8696ec"},
    // {value: "Girls", label: "Girls", short: "GIRL", color: "#133edc"},
    // {value: "Heros", label: "Heros", short: "HERO", color: "#c51dae"},
    // {value: "Notables", label: "Notables", short: "NOTE", color: "#e4ff00"},
    // {value: "Gymnastics", label: "Gymnastics", short: "GYM", color: "#ce1995"},
    // {value: "Endurance", label: "Endurance", short: "END", color: "#4d2647"},
    // {value: "Games", label: "Games", short: "GAMES", color: "#3e6e2e"},
    // {value: "Open", label: "Open", short: "OPEN", color: "#71945a"},
    // {value: "Crossfit.com", label: "Crossfit.com", short: "CF.C", color: "#a453af"},
    // {value: "Benchmarks", label: "Benchmarks", short: "BM", color: "#5be01e"},
    // {value: "Strength", label: "Strength", short: "STREN", color: "#fddf01"},
    {value: "Gespeicherte", label: "Gespeicherte", short: "SAVED", color: "rgb(148,148,148)"},
    {value: "Neu erstellen", label: "Neu erstellen", short: "NEW", color: "rgb(148,148,148)"}
];

export const componentList = [
    {id: 11, label: "Fran", short: "FRAN"},
    {id: 12, label: "Diane", short: "DIANE"},
    {id: 13, label: "Murph", short: "MURPH"},
    {id: 14, label: "Helen", short: "HELEN"},
    {id: 15, label: "Linda", short: "LINDA"},
    {id: 16, label: "Babara", short: "BABARA"},
    {id: 17, label: "DT", short: "DT"},
    {id: 18, label: "Fight Gone Bad", short: "FGB"}
];

export function getRemainingTickets(ego, date){
    let start;
    let end;
    let count = ego?.ticketsMax;

    if(!count)
        return 0
    if(ego?.contract){
        start = new Date(ego.contract.startDate)
        end = new Date(ego.contract.endDate)
        if(start > date || end < date){
            return 0
        }
        if(ego.contract.repeat.startsWith("weekly")){
            start = new Date(date);
            start.setDate(start.getDate() - (start.getDay() > 0 ? start.getDay() - 1 : 6));
            start.setHours(0, 0, 0);
            end = new Date(start);
            end.setDate(end.getDate() + 6);
            end.setHours(23, 59, 59);
        }
        else if(ego.contract.repeat.startsWith("monthly")){
            start = new Date(date);
            start.setDate(1);
            start.setHours(0, 0, 0);
            end = new Date(start);
            end.setMonth(end.getMonth() + 1);
            end.setDate(0);
            end.setHours(23, 59, 59);
        }
        else if(ego.contract.repeat.startsWith("all_in")){
            return -1;
        }
    } else {
        return 0
    }

    ego?.courses?.map(course => {
        const courseStart = new Date(course.startDate + "T" + course.startTime);
        if(courseStart > start && courseStart < end && (course.status !== "free" && course.status !== "kostenlos"))
            count--
    });

    return count > 0 ? count : 0;
}
